import {
  Receipt,
  Landmark,
  BookOpen,
  Scroll,
  KeyRound,
  HeartPulse,
  Scale,
  Files,
  Folder,
} from "lucide-react";

export const CATEGORIES = [
  {
    key: "receipts",
    label: "Receipts",
    icon: Receipt,
    badge: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/50 dark:text-emerald-200",
    dot: "bg-emerald-500",
    tint: "bg-emerald-50 dark:bg-emerald-950/40",
    border: "border-emerald-200 dark:border-emerald-800/60",
    iconColor: "#059669",
  },
  {
    key: "taxes",
    label: "Taxes",
    icon: Landmark,
    badge: "bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-200",
    dot: "bg-amber-500",
    tint: "bg-amber-50 dark:bg-amber-950/40",
    border: "border-amber-200 dark:border-amber-800/60",
    iconColor: "#D97706",
  },
  {
    key: "manuals",
    label: "Manuals",
    icon: BookOpen,
    badge: "bg-sky-100 text-sky-800 dark:bg-sky-900/50 dark:text-sky-200",
    dot: "bg-sky-500",
    tint: "bg-sky-50 dark:bg-sky-950/40",
    border: "border-sky-200 dark:border-sky-800/60",
    iconColor: "#0284C7",
  },
  {
    key: "wills",
    label: "Wills",
    icon: Scroll,
    badge: "bg-rose-100 text-rose-800 dark:bg-rose-900/50 dark:text-rose-200",
    dot: "bg-rose-500",
    tint: "bg-rose-50 dark:bg-rose-950/40",
    border: "border-rose-200 dark:border-rose-800/60",
    iconColor: "#E11D48",
  },
  {
    key: "passwords",
    label: "Passwords",
    icon: KeyRound,
    badge: "bg-violet-100 text-violet-800 dark:bg-violet-900/50 dark:text-violet-200",
    dot: "bg-violet-500",
    tint: "bg-violet-50 dark:bg-violet-950/40",
    border: "border-violet-200 dark:border-violet-800/60",
    iconColor: "#7C3AED",
  },
  {
    key: "medical",
    label: "Medical",
    icon: HeartPulse,
    badge: "bg-teal-100 text-teal-800 dark:bg-teal-900/50 dark:text-teal-200",
    dot: "bg-teal-500",
    tint: "bg-teal-50 dark:bg-teal-950/40",
    border: "border-teal-200 dark:border-teal-800/60",
    iconColor: "#0D9488",
  },
  {
    key: "legal",
    label: "Legal",
    icon: Scale,
    badge: "bg-stone-200 text-stone-800 dark:bg-stone-700 dark:text-stone-200",
    dot: "bg-stone-500",
    tint: "bg-stone-100 dark:bg-stone-800/60",
    border: "border-stone-300 dark:border-stone-700",
    iconColor: "#57534E",
  },
  {
    key: "misc",
    label: "Misc",
    icon: Files,
    badge: "bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-200",
    dot: "bg-orange-500",
    tint: "bg-orange-50 dark:bg-orange-950/40",
    border: "border-orange-200 dark:border-orange-800/60",
    iconColor: "#EA580C",
  },
];

// Color palette for user-created custom categories. Literal class strings so Tailwind keeps them.
export const COLOR_SCHEMES = {
  emerald: { badge: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/50 dark:text-emerald-200", dot: "bg-emerald-500", tint: "bg-emerald-50 dark:bg-emerald-950/40", border: "border-emerald-200 dark:border-emerald-800/60", iconColor: "#059669" },
  amber: { badge: "bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-200", dot: "bg-amber-500", tint: "bg-amber-50 dark:bg-amber-950/40", border: "border-amber-200 dark:border-amber-800/60", iconColor: "#D97706" },
  sky: { badge: "bg-sky-100 text-sky-800 dark:bg-sky-900/50 dark:text-sky-200", dot: "bg-sky-500", tint: "bg-sky-50 dark:bg-sky-950/40", border: "border-sky-200 dark:border-sky-800/60", iconColor: "#0284C7" },
  rose: { badge: "bg-rose-100 text-rose-800 dark:bg-rose-900/50 dark:text-rose-200", dot: "bg-rose-500", tint: "bg-rose-50 dark:bg-rose-950/40", border: "border-rose-200 dark:border-rose-800/60", iconColor: "#E11D48" },
  violet: { badge: "bg-violet-100 text-violet-800 dark:bg-violet-900/50 dark:text-violet-200", dot: "bg-violet-500", tint: "bg-violet-50 dark:bg-violet-950/40", border: "border-violet-200 dark:border-violet-800/60", iconColor: "#7C3AED" },
  teal: { badge: "bg-teal-100 text-teal-800 dark:bg-teal-900/50 dark:text-teal-200", dot: "bg-teal-500", tint: "bg-teal-50 dark:bg-teal-950/40", border: "border-teal-200 dark:border-teal-800/60", iconColor: "#0D9488" },
  stone: { badge: "bg-stone-200 text-stone-800 dark:bg-stone-700 dark:text-stone-200", dot: "bg-stone-500", tint: "bg-stone-100 dark:bg-stone-800/60", border: "border-stone-300 dark:border-stone-700", iconColor: "#57534E" },
  orange: { badge: "bg-orange-100 text-orange-800 dark:bg-orange-900/50 dark:text-orange-200", dot: "bg-orange-500", tint: "bg-orange-50 dark:bg-orange-950/40", border: "border-orange-200 dark:border-orange-800/60", iconColor: "#EA580C" },
  indigo: { badge: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/50 dark:text-indigo-200", dot: "bg-indigo-500", tint: "bg-indigo-50 dark:bg-indigo-950/40", border: "border-indigo-200 dark:border-indigo-800/60", iconColor: "#4F46E5" },
  cyan: { badge: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/50 dark:text-cyan-200", dot: "bg-cyan-500", tint: "bg-cyan-50 dark:bg-cyan-950/40", border: "border-cyan-200 dark:border-cyan-800/60", iconColor: "#0891B2" },
  lime: { badge: "bg-lime-100 text-lime-800 dark:bg-lime-900/50 dark:text-lime-200", dot: "bg-lime-500", tint: "bg-lime-50 dark:bg-lime-950/40", border: "border-lime-200 dark:border-lime-800/60", iconColor: "#65A30D" },
  fuchsia: { badge: "bg-fuchsia-100 text-fuchsia-800 dark:bg-fuchsia-900/50 dark:text-fuchsia-200", dot: "bg-fuchsia-500", tint: "bg-fuchsia-50 dark:bg-fuchsia-950/40", border: "border-fuchsia-200 dark:border-fuchsia-800/60", iconColor: "#C026D3" },
};

export const COLOR_OPTIONS = Object.keys(COLOR_SCHEMES);

const _map = CATEGORIES.reduce((acc, c) => {
  acc[c.key] = c;
  return acc;
}, {});

let _custom = [];

const _buildCustom = (c) => {
  const scheme = COLOR_SCHEMES[c.color] || COLOR_SCHEMES.stone;
  return { key: c.key, label: c.label, icon: Folder, custom: true, color: c.color, ...scheme };
};

// Merge household-created categories into the runtime map so getCategory() renders their label + color everywhere.
export const registerCustomCategories = (list = []) => {
  Object.keys(_map).forEach((k) => { if (_map[k]?.custom) delete _map[k]; });
  _custom = (list || []).map(_buildCustom);
  _custom.forEach((c) => { _map[c.key] = c; });
};

export const allCategories = () => [...CATEGORIES, ..._custom];

export const CATEGORY_MAP = _map;

export const getCategory = (key) => _map[key] || _map.misc;
